var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaskGroup89(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1241,
    viewBox: "0 0 1920 1241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6039",
    "data-name": "Rectangle 6039",
    width: 1920,
    height: 1241,
    transform: "translate(127 155)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 2.54,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f3040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07111a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1356",
    x: 1351,
    y: 378,
    width: 323,
    height: 324,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: -30,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: -0.414,
    y2: 0.349,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1357",
    x: 1039,
    y: 624,
    width: 947,
    height: 945,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: -30,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1356-2",
    x: 307,
    y: 378,
    width: 323,
    height: 324,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: -30,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1357-2",
    x: -5,
    y: 624,
    width: 947,
    height: 945,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: -30,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1356-3",
    x: 776,
    y: 228.001,
    width: 428,
    height: 428,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: -30,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: -0.309,
    y2: 0.337,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1357-3",
    x: 308,
    y: 598,
    width: 1364,
    height: 1363,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: -30,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000910",
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 0.265,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07111a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07111a",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_89",
    "data-name": "Mask Group 89",
    transform: "translate(-127 -155)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8541",
    "data-name": "Group 8541",
    transform: "translate(0 125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8538",
    "data-name": "Group 8538",
    transform: "translate(0 576.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8540",
    "data-name": "Group 8540",
    transform: "translate(152 -78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8537",
    "data-name": "Group 8537",
    transform: "translate(1044.343 -0.065)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1069.34, -468)",
    filter: "url(#Ellipse_1356)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1356-4",
    "data-name": "Ellipse 1356",
    cx: 101.5,
    cy: 102,
    rx: 101.5,
    ry: 102,
    transform: "translate(1381 468)",
    opacity: 0.9,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1069.34, -468)",
    filter: "url(#Ellipse_1357)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1357-4",
    "data-name": "Ellipse 1357",
    cx: 413.5,
    cy: 412.5,
    rx: 413.5,
    ry: 412.5,
    transform: "translate(1069 714)",
    opacity: 0.9,
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8539",
    "data-name": "Group 8539",
    transform: "translate(0 -0.065)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25, -468)",
    filter: "url(#Ellipse_1356-2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1356-5",
    "data-name": "Ellipse 1356",
    cx: 101.5,
    cy: 102,
    rx: 101.5,
    ry: 102,
    transform: "translate(337 468)",
    opacity: 0.9,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -25, -468)",
    filter: "url(#Ellipse_1357-2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1357-5",
    "data-name": "Ellipse 1357",
    cx: 413.5,
    cy: 412.5,
    rx: 413.5,
    ry: 412.5,
    transform: "translate(25 714)",
    opacity: 0.9,
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8535",
    "data-name": "Group 8535",
    transform: "translate(465.262 347.979)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -338.26, -317.98)",
    filter: "url(#Ellipse_1356-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1356-6",
    "data-name": "Ellipse 1356",
    cx: 154,
    cy: 154,
    r: 154,
    transform: "translate(806 318)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -338.26, -317.98)",
    filter: "url(#Ellipse_1357-3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1357-6",
    "data-name": "Ellipse 1357",
    cx: 622,
    cy: 621.5,
    rx: 622,
    ry: 621.5,
    transform: "translate(338 688)",
    fill: "url(#linear-gradient-6)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6040",
    "data-name": "Rectangle 6040",
    width: 1920,
    height: 374,
    transform: "translate(2047 1424) rotate(180)",
    fill: "url(#linear-gradient-7)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup89);
export default __webpack_public_path__ + "static/media/mask-group-89.8c8a8d24a5c2c47c24e6664f629b77f2.svg";
export { ForwardRef as ReactComponent };